// @flow

export default {
  latest: ['last 1 ios_saf major version'],
  maintenance: ['last 2 ios_saf major versions'],
  next: ['unreleased ios_saf versions', 'last 1 ios_saf major version'],
};
